import React, { useState, useRef, useEffect } from "react";
import "../css/experience.css";

const DescriptionWrapper = ({ isOpen, children }) => {
    const ref = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            setHeight(isOpen ? ref.current.scrollHeight : 0);
        };
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, [isOpen]);

    return (
        <div className="description-wrapper" style={{ height: `${height}px` }}>
            <div ref={ref} style={{ width: "100%" }}>
                {children}
            </div>
        </div>
    );
};

const Experience = () => {
    const [expanded, setExpanded] = useState({});

    const toggle = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <div className="experience-container">
            <div className="job-container">
                <div className="title-container">
                    <img src="ITimage.png" alt="IT Logo" />
                    <h2 className="job-title">Lead IT Technician</h2>
                    <h2 className="company-title">Oregon State Univ.</h2>
                </div>
                <DescriptionWrapper isOpen={expanded["it"]}>
                    <div className="description-container">
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    Delivered responsive technical support to faculty, staff, and students by diagnosing and resolving a
                                    wide range of hardware, software, and network issues across multiple university systems.
                                </li>
                                <li>
                                    Created and maintained hundreds of Cyder entries to ensure accurate IP and DNS records, helping end
                                    users maintain consistent and reliable wired network connectivity throughout campus.
                                </li>
                            </ul>
                        </div>
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    Administered Active Directory infrastructure, including the creation, modification, and deactivation of
                                    user accounts, and enforced access policies using group policy management.
                                </li>
                                <li>
                                    Leveraged PowerShell scripting to automate repetitive tasks, improving efficiency and consistency in
                                    account provisioning, permission updates, and other daily IT operations.
                                </li>
                            </ul>
                        </div>
                    </div>
                </DescriptionWrapper>
                <button className="expand-description" onClick={() => toggle("it")}>
                    {expanded["it"] ? "Collapse ▲" : "Expand ▼"}
                </button>
            </div>

            <div className="job-container">
                <div className="title-container">
                    <img src="osuMP.png" alt="Microsoft Programmer Logo" />
                    <h2 className="job-title">Microsoft Programmer</h2>
                    <h2 className="company-title">Oregon State Univ.</h2>
                </div>
                <DescriptionWrapper isOpen={expanded["mp"]}>
                    <div className="description-container">
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    As a Microsoft Programmer for Oregon State University's School of Electrical Engineering and Computer
                                    Science, I developed scalable software solutions to improve operational efficiency and data consistency
                                    across administrative systems.
                                </li>
                                <li>
                                    I designed and implemented a workflow automation system integrated with Microsoft Teams and Outlook,
                                    enabling staff to create and assign tasks instantly. This reduced delays, improved team coordination,
                                    and streamlined day-to-day communications.
                                </li>
                            </ul>
                        </div>
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    I optimized the university's application approval process by creating a Power Automate flow that
                                    replaced several manual steps. This automation significantly reduced processing time, minimized errors,
                                    and improved overall workflow reliability.
                                </li>
                                <li>
                                    Throughout the project, I worked closely with university staff to identify pain points and tailor each
                                    solution to real-world needs, gaining hands-on experience with Microsoft 365 tools and modern workflow
                                    automation techniques.
                                </li>
                            </ul>
                        </div>
                    </div>
                </DescriptionWrapper>
                <button className="expand-description" onClick={() => toggle("mp")}>
                    {expanded["mp"] ? "Collapse ▲" : "Expand ▼"}
                </button>
            </div>

            <div className="job-container">
                <div className="title-container">
                    <img src="cyberlock.png" alt="Cyberlock Logo" />
                    <h2 className="job-title">Software Testing Intern</h2>
                    <h2 className="company-title">CyberLock</h2>
                </div>
                <DescriptionWrapper isOpen={expanded["cyberlock"]}>
                    <div className="description-container">
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    At Videx, I collaborated closely with cross-functional teams, including software developers and product
                                    managers, to ensure smooth communication and alignment across the development lifecycle. My role focused
                                    heavily on supporting efficient bug tracking and fostering a transparent workflow between engineering
                                    and QA.
                                </li>
                                <li>
                                    A core part of my role involved identifying, documenting, and reporting software bugs using Bugify. I
                                    worked hands-on with developers to prioritize and debug issues, ensuring quick turnaround times and
                                    contributing to the stability and reliability of production releases.
                                </li>
                            </ul>
                        </div>
                        <div className="description-half-containers">
                            <ul>
                                <li>
                                    Beyond testing responsibilities, I was also responsible for setting up and maintaining CyberAudit web
                                    servers on Rocky 8 Linux. I automated repetitive tasks using Python scripts and integrated the Videx
                                    Translation Language SDK with Google Cloud APIs to improve language handling functionality within the
                                    platform.
                                </li>
                                <li>
                                    I was an active participant in daily Agile stand-up meetings, where I provided testing updates,
                                    highlighted blockers, and suggested practical improvements to enhance our testing processes. My
                                    contributions helped improve team coordination and promoted faster issue resolution.
                                </li>
                            </ul>
                        </div>
                    </div>
                </DescriptionWrapper>
                <button className="expand-description" onClick={() => toggle("cyberlock")}>
                    {expanded["cyberlock"] ? "Collapse ▲" : "Expand ▼"}
                </button>
            </div>
        </div>
    );
};

export default Experience;
